// extracted by mini-css-extract-plugin
module.exports = {"container":"whatsapp-button_container__2s2Ig","icon":"whatsapp-button_icon__1DEH1"};